import { Formio } from 'formiojs';
import FormioContrib from '../src/Components';
(Formio as any).use({components: FormioContrib});
export default FormioContrib;

